import styles from './header.module.css'
import Logo from '../../assets/mesh_in_logo_in_row.svg'
import { MenuButton } from './menuButton'
import {
  useFloating,
  autoUpdate,
  offset,
  flip,
  shift,
  useClick,
  useDismiss,
  useRole,
  useInteractions,
  FloatingPortal,
} from '@floating-ui/react'
import { useState } from 'react'
import { PortalMenu } from './menu'
import { useMessagingService, ReauthNeededInfoSaver } from '../../agent'
import { PrimaryButton } from '../common'
import { useSiteInfo } from '../../siteInfo/provider'

export const Header = () => {
  const goHome = () => (window.location.href = '/')
  const messagingService = useMessagingService()
  const isAnonymous = messagingService.isAnonymous()
  const humanProxyId = useSiteInfo()?.proxyLinkCode

  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => setIsOpen(it => !it)

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: 'bottom-end',
    strategy: 'fixed',
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(0),
      flip(),
      shift({ padding: 32 }), // keeps it inside viewport with margin
    ],
  })

  const click = useClick(context)
  const dismiss = useDismiss(context, { outsidePress: true, escapeKey: true })
  const role = useRole(context, { role: 'menu' })

  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss,
    role,
  ])

  const meshIn = () => {
    const reauthInfoSaver = new ReauthNeededInfoSaver()
    reauthInfoSaver.saveReauthNeededInfo()
    window.location.href = '/reauth'
  }

  return (
    <div className={styles.header} ref={refs.setPositionReference}>
      <img
        src={Logo}
        className={styles.logo}
        alt="Mesh Logo"
        onClick={goHome}
      />

      {isAnonymous ? (
        <PrimaryButton
          label="mesh in"
          icon={
            <span style={{ fontFamily: 'MeshIcons', fontSize: '20px' }}>
              {'\ue826'}
            </span>
          }
          className={styles.meshInButton}
          style={{ padding: '8px 32px', gap: '12px' }}
          onClick={meshIn}
        />
      ) : (
        <>
          <MenuButton
            ref={refs.setReference}
            humanProxyId={humanProxyId}
            {...getReferenceProps()}
            aria-pressed={isOpen}
            isActive={isOpen}
            onClick={toggleOpen}
          />

          {isOpen && (
            <div className={styles.overlay} onClick={() => setIsOpen(false)} />
          )}

          {isOpen && (
            <FloatingPortal>
              <div
                ref={refs.setFloating}
                {...getFloatingProps()}
                style={{
                  ...floatingStyles,
                  zIndex: 1000,
                }}
              >
                <PortalMenu onMenuItemPressed={() => setIsOpen(false)} />
              </div>
            </FloatingPortal>
          )}
        </>
      )}
    </div>
  )
}
